import * as types from './mutation-types'
import Vue from 'vue'
import { IDataPoolState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations: MutationTree<IDataPoolState> = {
  //Gestion des recherches de missionsFleet
  [types.DATAPOOL_REQUEST]: state => {
    state.status = 'loading dataPool'
  },
  [types.DATAPOOL_SUCCESS]: (state, dataPoolItems: Array<AloDataPoolItem>) => {
    state.status = 'success loading dataPool'
    dataPoolItems.forEach(item => {
      if (item.dtaId) {
        Vue.set(state.dataPoolItemsById, item.dtaId, item)
      }
    })
  },
  [types.DATAPOOL_ERROR]: state => {
    state.status = 'error loading dataPool'
  },

  [types.DATAPOOL_MSG_ACCUEIL_REQUEST]: state => {
    state.status = 'loading home message info'
  },
  [types.DATAPOOL_MSG_ACCUEIL_SUCCESS]: (state, dataPoolItem: Array<AloDataPoolItem>) => {
    state.status = 'success home message info'
    dataPoolItem.forEach(d =>{
      Vue.set(state.dataPoolItemsById, d.dtaId!, d)    
    })    
  },
  [types.DATAPOOL_MSG_ACCUEIL_ERROR]: state => {
    state.status = 'error loading home message info'
  },

  [types.DATAPOOL_ENSURE]: (state, { usrId = null, fullKey = null }) => {
    state.status = 'ensure dataPool'
  },
  [types.DATAPOOL_UPDATE_REQUEST]: state => {
    state.status = 'update dataPool'
  },
  /**
   * @param {AloDataPoolItem} resp
   */
  [types.DATAPOOL_UPDATE_SUCCESS]: (state, dataPoolItem: AloDataPoolItem) => {
    state.status = 'success update dataPool'
    if (dataPoolItem.dtaId) {
      Vue.set(state.dataPoolItemsById, dataPoolItem.dtaId, dataPoolItem)
    }
  },
  [types.DATAPOOL_UPDATE_ERROR]: state => {
    state.status = 'error update dataPool'
  },
  [types.DATAPOOL_DELETE]: (state, dataPoolItem: AloDataPoolItem) => {
    if (dataPoolItem.dtaId) Vue.delete(state.dataPoolItemsById, dataPoolItem.dtaId)
  }
}

export default mutations
